import { UseQueryResult, useQuery } from "@tanstack/react-query";

import { CounselorResponse, counselorsApi } from "@/api";
import { QueryKey } from "@/query/Query";

export function useCounselorsQuery<TData = CounselorResponse[]>(
  select?: (data: CounselorResponse[]) => TData
): UseQueryResult<TData> {
  return useQuery({
    queryKey: [QueryKey.Counselors],
    queryFn: () => counselorsApi.getAllCounselors(),
    staleTime: Infinity,
    meta: { loadingScope: "pageContent" },
    select,
  });
}
